export default "/bitrix/js/landing/ui/field/paysystemsselectorfield/dist/image/default-pay-system-image.svg"